var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title-section cover-section",attrs:{"id":_vm.src}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-wrapper",class:{'translate': _vm.translate}},[_c('h2',[_vm._t("title")],2),_c('p',{staticClass:"subheading"},[_vm._t("subheading")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }